$(function(){
  setupGiftCertificateNames();
})

function setupGiftCertificateNames() {
  var namesRows = $('tr[id*=names-row]'); 
  
  if ($('#certificateCount').length > 0) {
    onCertificatesCountChange($('#certificateCount').val(), parseInt($('#certificateCount').attr('data-discount')), namesRows);
    $('#certificateCount').change(function() {
      onCertificatesCountChange($('#certificateCount').val(), parseInt($('#certificateCount').attr('data-discount')), namesRows);
    }); 
  }
} 
 
function onCertificatesCountChange(count, discountPerUnit, namesRows) {

//    var count = 1*value + 1;  // 1* is there to cast string to integer (otherwise "+ 1" will just add string "1")
    
    namesRows.each(function(i) {
      if (i >= count) $(this).addClass('hidden');
      if (i < count) $(this).removeClass('hidden');
    });

    $('.price').text(getPriceForGiftCertificate(count, discountPerUnit));

    if ($('input[name=code]', '.codebox').val()) {
        $('.checkCode').click();
    }

    if (count > 1)
      $('.discountInfoDiv').removeClass('hidden');
    else $('.discountInfoDiv').addClass('hidden'); 

  
}

function getPriceForGiftCertificate(count, discountPerUnit) {
  var price = APP_PRICE;
  var totalPrice = price * count;

  if (count > 1) {
    totalPrice = totalPrice - discountPerUnit * count;
  }

  return totalPrice;
}
